(ns practitest.frontend.common.logger)

(defn log* [severity args]
  (when-let [m (aget js/console (name severity))]
    (apply m
           (if ^boolean js/goog.DEBUG
             args
             (map clj->js args)))))

(defn debug [& args]
  (log* :debug args))

(defn info [& args]
  (log* :info args))

(defn warn [& args]
  (log* :warn args))

(defn error [& args]
  (log* :error args))
